import types from './types'
import axios from 'axios'

export default {

  reset ({ commit }) {
    commit(types.RESET)
  },

  async getDashboardNews ({ commit }, { limit }) {
    commit(types.GET_DASHBOARD_LIST.REQUEST)
    try {
      commit(types.GET_DASHBOARD_LIST.SUCCESS, await axios.get('/api/newsDashboardAll', { params: { l: limit, sf: 'createdAt', so: 'desc' } }))
    } catch (err) {
      commit(types.GET_DASHBOARD_LIST.FAILURE)
    } finally {
    }
  },

  async getNewsDetails ({ commit }, { id }) {
    commit(types.GET_ITEM.REQUEST, { id })
    try {
      commit(types.GET_ITEM.SUCCESS, await axios.get(`/api/news/${id}`, {}))
    } catch (err) {
      commit(types.GET_ITEM.FAILURE)
    } finally {
    }
  }
}
